module.exports = __webpack_public_path__ + "static/media/msp_05.bb9ef767.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msp_05.png
// module id = 86
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17